import Analytics from '@jonni/helpers/analytics';
import { Logo, LogoContainer, OnboardingTopbarContainer, Padding } from '@jonni/styles/signup/onboardingMobileStyles';
import { BlueWhatsappIcon, HeaderContainer, HeaderLogo, JonniLogo } from '@jonni/styles/signup/onboardingSteps';
import { WhatsappWhiteIcon } from '@jonni/styles/topbar';
import { Theme, useMediaQuery } from '@mui/material';
import React, { useCallback } from 'react';

interface OnboardingHeaderProps {
  isContentHeader?: boolean;
}

const OnboardingHeader = React.memo<OnboardingHeaderProps>(({ isContentHeader }) => {
  const isMobileWidth = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  const onAppClick = useCallback((name: string) => {
    Analytics.logAppButtonClick(name);
  }, []);

  if (!isMobileWidth && isContentHeader) {
    return (
      <HeaderContainer>
        <HeaderLogo>
          <a href={'https://www.' + process.env.GATSBY_JONNI_DOMAIN}>
            <JonniLogo />
          </a>
        </HeaderLogo>
        <a
          onClick={() => onAppClick('whatsapp')}
          href={process.env.GATSBY_WHATSAPP_PAGE_URL}
          target="_blank"
          rel="noreferrer">
          <BlueWhatsappIcon />
        </a>
      </HeaderContainer>
    );
  }

  if (isMobileWidth && !isContentHeader) {
    return (
      <>
        <OnboardingTopbarContainer>
          <LogoContainer>
            <a href={'https://www.' + process.env.GATSBY_JONNI_DOMAIN}>
              <Logo />
            </a>
          </LogoContainer>
          <a
            style={{ marginTop: '3px' }}
            onClick={() => onAppClick('whatsapp')}
            href={process.env.GATSBY_WHATSAPP_PAGE_URL}
            target="_blank"
            rel="noreferrer">
            <WhatsappWhiteIcon />
          </a>
        </OnboardingTopbarContainer>
        <Padding />
      </>
    );
  }

  return null;
});

export default OnboardingHeader;
